function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 15L1 8l7-7",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgBackSmallSidebar = function SvgBackSmallSidebar(props) {
  return React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 9 16",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='7' height='14' viewBox='0 0 9 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M8 15L1 8L8 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' /%3E %3C/svg%3E";
export { SvgBackSmallSidebar as ReactComponent };